import { useEffect, useState } from "react";
import { api } from "../../lib/apiClient";
import { PageHead, Card, StatusPill, FilterBar, Select, TextInput, Loading, Err, tableStyles, EmptyState } from "./_shared";

const SEVERITIES = ["info", "warning", "error", "critical"];
const SOURCES = ["worker", "auth", "credits", "admin", "api", "scheduler"];

export default function SystemEvents() {
  const [items, setItems] = useState(null);
  const [err, setErr] = useState("");
  const [severity, setSeverity] = useState("");
  const [source, setSource] = useState("");
  const [q, setQ] = useState("");

  useEffect(() => {
    const url = new URLSearchParams();
    if (severity) url.set("severity", severity);
    if (source) url.set("source", source);
    api.get("/api/admin/system-events" + (url.toString() ? "?" + url.toString() : ""))
      .then((d) => setItems(d.items)).catch((e) => setErr(e.message));
  }, [severity, source]);

  if (err) return <Err msg={err} />;
  const visible = (items || []).filter((e) =>
    !q || (e.event_type || "").includes(q) || (e.message || "").toLowerCase().includes(q.toLowerCase())
  );

  return (
    <div data-testid="admin-system-events">
      <PageHead title="System events" sub={`${items?.length ?? 0} events · last 500`} />
      <FilterBar>
        <TextInput value={q} onChange={setQ} placeholder="Search events…" data-testid="events-search" />
        <Select value={severity} onChange={setSeverity} placeholder="All severities" options={SEVERITIES} data-testid="events-filter-severity" />
        <Select value={source} onChange={setSource} placeholder="All sources" options={SOURCES} data-testid="events-filter-source" />
      </FilterBar>

      {!items ? <Loading /> : visible.length === 0 ? (
        <EmptyState title="No system events match" description="Either your filters are too narrow or everything is healthy 🎉" />
      ) : (
        <Card pad={0} style={{ overflow: "hidden" }}>
          <table style={tableStyles.table}>
            <thead>
              <tr>
                <th style={tableStyles.th}>When</th>
                <th style={tableStyles.th}>Event</th>
                <th style={tableStyles.th}>Source</th>
                <th style={tableStyles.th}>Severity</th>
                <th style={tableStyles.th}>Message</th>
              </tr>
            </thead>
            <tbody>
              {visible.map((e) => (
                <tr key={e.id || (e.created_at + e.event_type)} style={{ borderTop: "1px solid var(--pl-border)" }}>
                  <td style={{ ...tableStyles.td, fontSize: 11 }}>{(e.created_at || "").slice(0, 19)}</td>
                  <td style={{ ...tableStyles.td, fontWeight: 700 }}>{e.event_type}</td>
                  <td style={tableStyles.td}>{e.source || "—"}</td>
                  <td style={tableStyles.td}><StatusPill s={e.severity || "info"} /></td>
                  <td style={tableStyles.td}>{e.message || "—"}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </div>
  );
}
